import { render, staticRenderFns } from "./CrudPermissionGrid.vue?vue&type=template&id=1dd8fca8"
import script from "./CrudPermissionGrid.vue?vue&type=script&lang=js"
export * from "./CrudPermissionGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports